import PostUpdate from './post-update';

export default PostUpdate;